export default function ( { store, redirect, route, app } ) {
	// 관리자 권한 체크가 필요 없는 페이지 목록
	const publicPages = [
		'/kccam/manager/login/manager_login',
		// 다른 예외 페이지들...
	];

	// 현재 경로가 public 페이지인지 확인
	const isPublicPage = publicPages.includes( route.path );

	// 관리자 페이지인지 확인 (manager가 포함되고 public 페이지가 아닌 경우)
	const isManagerPage = route.path.includes( '/manager' ) && !isPublicPage;

	// 로그인 여부 확인
	const isLoggedIn = store.state.login.loginUser && store.state.login.loginUser.userId;

	// 관리자 권한 확인
	const isAdmin = isLoggedIn &&
		app.$amConstant.USER_TYPE.ADMIN === store.state.login.loginUser.userType;

	// 관리자 페이지에 접근하려는데 관리자가 아닌 경우
	if ( isManagerPage && !isAdmin ) {
		console.log( '관리자 페이지에 접근하려는데 관리자가 아닌 경우' );
		return redirect( '/kccam/manager/login/manager_login' );
	}
}
